module.exports = __webpack_public_path__ + "static/media/archive.7bf4bcb8.svg";